import { useTranslation } from 'react-i18next';
import { IValidationResults } from '../../../data/models/validation';

export default function useFindErrorMessage(albumErrors: IValidationResults[]) {
  const { t } = useTranslation();
  return (field: string) => {
    const errorType: any = albumErrors.find(
      (va) => va.fieldName === field
    )?.errorType;
    let errorMessage: string = '';
    if (errorType) {
      errorMessage = t(
        'validationAlert.productEditMode.' +
          field +
          '.' +
          errorType +
          '.ErrorMessage'
      );
    }
    return errorMessage;
  };
}
